module.exports = __webpack_public_path__ + "img/Weapon_300.d3159c5e.png";